module.exports = require("!!vue-loader!../../node_modules/v-markdown-loader/_cache/v2.2.1-rc.3-93.vue");


//////////////////
// WEBPACK FOOTER
// ./en/changelog/v2.2.1-rc.3.md
// module id = 510
// module chunks = 322